<template>
<div class="timeline-entry timeline-entry-universal-flow">
    <div class="row pr-3">
        <div class="col line-section pr-0 profile-image-sm-width-flex d-flex flex-column align-items-center">
            <div class="line line-pre mb-1"></div>
            <div class="img-container">
              <img class="profile-image-sm rounded-circle shadow lg" :src="activity.activityDetail.from.avatarPath" />
            </div>
            <div class="line flex-grow-1 mt-1"></div>
        </div>
        <div class="col detail-part pt-2 pl-2 border-bottom">
            <div class="pt-2 pb-3 pl-2 pr-2">
                <p class="font-weight-normal m-0">{{text}} <span v-if="activity.activityDetail.contractNo !== null">#{{activity.activityDetail.contractNo}}</span></p>
                <p class="m-0 text-secondary font-weight-lighter"><small>{{$dayjs(activity.datetime).fromNow()}}</small></p>
            </div>
            <div class="card p-3 mb-4 shadow">
                <button class="btn btn-primary rounded-pill" @click="navigate()"><small>ชำระเงิน</small></button>
            </div>
        </div>
    </div>
</div>
</template>

<script>
export default {
  methods: {
    navigate () {
      window.location.assign(`${window.BASE_URL}member/pay#/02/${this.activity.activityDetail.contractId}?contractNo=${this.activity.activityDetail.contractNo}`)
    }
  },
  props: ['activity', 'text']
}
</script>

<style lang="scss">
</style>
